import Stars from 'components/ui/Stars';
import { formatNumber } from 'utils/number';
import { useTranslation } from 'hooks/useTranslation';
import styles from './ReviewStats.module.scss';

type Props = {
  stats: Record<string, number>;
};

const ReviewStats = ({ stats }: Props): JSX.Element | null => {
  const { locale, t } = useTranslation();

  if (!stats) {
    return null;
  }

  const {
    avg_rating,
    avg_friendliness,
    avg_facilities,
    count_1_star,
    count_2_star,
    count_3_star,
    count_4_star,
    count_5_star,
    total,
  } = stats;

  const statsArray = [
    count_5_star,
    count_4_star,
    count_3_star,
    count_2_star,
    count_1_star,
  ];

  return (
    <div className={styles.reviewStats}>
      <div className={styles.reviewStatsWrapper}>
        <div className={styles.reviewStatsSection}>
          <div className={styles.reviewStatsSectionAverage}>
            <div>
              <div>{formatNumber(avg_rating.toFixed(1), locale)}</div>
              <div>
                <Stars rating={avg_rating} />
              </div>
            </div>
            <p>
              ({formatNumber(total, locale)} {t('reviews.allCountries')})
            </p>
          </div>
        </div>
        <div className={styles.reviewStatsSection}>
          <div>
            <div>
              <p>{t('reviews.friendliness')}</p>
              <Stars rating={avg_friendliness} />
            </div>
            <div>
              <p>{t('reviews.facilities')}</p>
              <Stars rating={avg_facilities} />
            </div>
          </div>
        </div>
        <div className={styles.reviewStatsSection}>
          <div>
            {statsArray.map((count, i) => (
              <div key={i} className={styles.reviewStatsBarWrapper}>
                <div>
                  <span>
                    {statsArray.length - i} {t('reviews.star')}
                  </span>
                  <div className={styles.reviewStatsBar}>
                    <div style={{ width: `${(count * 100) / total}%` }} />
                  </div>
                  <span className={styles.reviewStatsBarCount}>
                    ({formatNumber(count, locale)})
                  </span>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ReviewStats;
